import { render, staticRenderFns } from "./GptApikey.vue?vue&type=template&id=4ed98516&scoped=true"
import script from "./GptApikey.vue?vue&type=script&lang=js"
export * from "./GptApikey.vue?vue&type=script&lang=js"
import style0 from "./GptApikey.vue?vue&type=style&index=0&id=4ed98516&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ed98516",
  null
  
)

export default component.exports